import MemberTable from './MemberTable';
import background from '../../assets/manage-bg.svg';
import { NavBarItem, NavBar } from '../navbar';
import { useActivityData } from './UseActivityData';
import { useTranslation } from 'react-i18next';
import { UserRole } from '../../models/userRole';
import { Link } from 'react-router-dom';

export default function ActivityDashboard({
  isChildActivityDashboard = false,
}: {
  isChildActivityDashboard: boolean;
}) {
  const [t] = useTranslation(['chatroom']);
  const { activityInfo, room } = useActivityData();

  if (!activityInfo || !room) {
    return <></>;
  }

  const style = {
    backgroundImage: `url(${background})`,
  };

  const { activity } = room;
  const mainDashboardMembers = activityInfo.members.filter(
    (member) => member.role !== UserRole.CUSTOMER
  );
  const childDashboardMembers = activityInfo.members.filter(
    (member) => member.role === UserRole.CUSTOMER
  );
  const members = isChildActivityDashboard
    ? childDashboardMembers
    : mainDashboardMembers;
  const day =
    activity.day > activity.duration ? activity.duration : activity.day;
  const viewChildGroupPermission =
    room.role === UserRole.OWNER || room.role === UserRole.ASSISTANT;

  return (
    <div className="relative">
      <NavBar title={NavBarItem.DASHBOARD} />
      <div
        style={style}
        className="px-4 py-6 h-[calc(100vh_-_3rem)] bg-no-repeat bg-center bg-cover bg-[#F8F8F8] flex flex-col"
      >
        <div className="flex flex-row justify-between">
          <div className="flex flex-col gap-2">
            <span className="text-2xl font-bold">{room.name}</span>
            <span className="text-manage-primary">
              {t('chatroom_info', '{{chatroom}}（{{count}} 人）', {
                chatroom: room.activity.name,
                count: members.length,
              })}
            </span>
          </div>
          {!isChildActivityDashboard && viewChildGroupPermission && (
            <Link
              to={`/chatrooms/${room.id}/child`}
              className="self-end font-medium border border-group-sub bg-opacity-30 bg-group-sub p-2 rounded text-center"
            >
              {t('activity_dashboard_view_child_group', '檢視子群組')}
            </Link>
          )}
        </div>
        <div className="container flex justify-between my-5">
          <span>
            {t('chatroom_send_task_count', '已發送 {{count}} 個任務', {
              count: activityInfo.sendTaskCount,
            })}
          </span>
          <span>
            {day}
            {t('chatroom_activated_day_count', ' / {{count}} 天', {
              count: activity.duration,
            })}
          </span>
        </div>
        {members.length > 0 ? (
          <MemberTable members={members} />
        ) : (
          <span className="text-center mt-8">
            {t('activity_dashboard_no_member', '沒有成員可以顯示')}
          </span>
        )}
      </div>
    </div>
  );
}
